import React, { useState } from "react";
import { Col, FormGroup, Input, Row } from "reactstrap";
import Modal from 'react-bootstrap/Modal';


export function InspectorNoteStep({ requesterNote, isTermAndConditionAccepted, updateFields }) {
    const [isTermsAndConditionChecked, setIsTermsAndConditionChecked] = useState(isTermAndConditionAccepted);
    const [showModal, setShowModal] = useState(false);

    const checkHandler = (event) => {
        setIsTermsAndConditionChecked(!isTermsAndConditionChecked);
        updateFields({ isTermAndConditionAccepted: !isTermsAndConditionChecked });
    }

    const openTermsAndConditionModal = () => {
        setShowModal(true);
    }

    const handleClose = () => {
        setShowModal(false);
    }

    return (
        <>
            {<Modal show={showModal} onHide={handleClose} centered size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Inspectiver Terms and Conditions for Inspection Orders</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="px-3">
                        <p><span><br /></span><span >Please read these Terms and Conditions carefully before placing an order with Inspectiver. By purchasing an inspection service, you agree to be bound by these Terms.</span></p>
                        <p><strong><span style={{ fontWeight: "bold" }}>1. Services Provided</span></strong></p>
                        <p><span>Inspectiver offers pre-purchase vehicle inspection services through independent inspectors. The inspection includes a visual and functional assessment based on the vehicle’s accessibility and the information provided by the seller.</span></p>
                        <p><strong><span style={{ fontWeight: "bold" }}>2. Scope of Inspection</span></strong></p>
                        <p>
                            <span>
                                <ul>
                                    <li>Inspections are non-invasive and based on visible and accessible areas of the vehicle.</li>
                                    <li>Inspectors do not dismantle any part of the vehicle.</li>
                                    <li>Road tests are only performed when the vehicle is legally operable and permitted by the seller.</li>
                                    <li>Inspections do not guarantee future vehicle performance or condition.</li>
                                </ul>
                            </span>
                        </p>
                        <p><strong><span style={{ fontWeight: "bold" }}>3. Limitations</span></strong></p>
                        <p>
                            <span>
                                <ul>
                                    <li>Inspectiver is not liable for hidden defects or issues that cannot be detected through visual inspection.</li>
                                    <li>The report reflects the vehicle’s condition only at the time of inspection.</li>
                                    <li>Inspectiver does not provide mechanical warranties or insurance.</li>
                                </ul>
                            </span>
                        </p>

                        <p><strong><span style={{ fontWeight: "bold" }}>4. Customer Responsibilities</span></strong></p>
                        <p>
                            <span>
                                <ul>
                                    <li>Provide accurate vehicle and seller information when placing an order.</li>
                                    <li>Ensure that the vehicle is available, accessible, and in a safe location for inspection.</li>
                                    <li>Customers may update inspection details (vehicle, seller, location, etc.) up to 24 hours prior to the scheduled appointment.</li>
                                </ul>
                            </span>
                        </p>
                        <p><strong><span style={{ fontWeight: "bold" }}>5. Payments and Refunds</span></strong></p>
                        <p>
                            <span>
                                <ul>
                                    <li>Full payment is required at the time of placing an order.</li>
                                    <li>Inspection orders are non-refundable, except in the case where Inspectiver is unable to conduct the inspection within 8 business days of the order being placed. In such cases, a full refund will be issued automatically.</li>
                                    <li>No refunds will be issued due to seller cancellation, no-show, or incorrect information provided by the customer.</li>
                                    <li>No refunds are issued once the inspection has been completed.</li>
                                </ul>
                            </span>
                        </p>
                        <p><strong><span style={{ fontWeight: "bold" }}>6. Report Delivery</span></strong></p>
                        <p>
                            <span>
                                <ul>
                                    <li>Inspection reports are typically delivered within 24 hours of the inspection via email or the Inspectiver platform.</li>
                                    <li>Customers are responsible for reviewing the report and making their purchase decision based on the information provided.</li>
                                </ul>
                            </span>
                        </p>

                        <p><strong><span style={{ fontWeight: "bold" }}>7. Liability Disclaimer</span></strong></p>
                        <p><span>Inspectiver and its inspectors are not responsible for:</span></p>
                        <p>
                            <span>
                                <ul>
                                    <li>Inaccuracies due to misinformation provided by the seller or customer.</li>
                                    <li>Future vehicle issues or repairs.</li>
                                    <li>Any decisions made based on the inspection report.</li>
                                </ul>
                            </span>
                        </p>

                        <p><strong><span style={{ fontWeight: "bold" }}>8. Use of Reports</span></strong></p>
                        <p>
                            <span>
                                <ul>
                                    <li>The inspection report is intended for the individual customer who ordered the service.</li>
                                    <li>Sharing, publishing, or distributing reports without written consent from Inspectiver is strictly prohibited.</li>
                                </ul>
                            </span>
                        </p>

                        <p><strong><span style={{ fontWeight: "bold" }}>9. Changes to Terms</span></strong></p>
                        <p><span>Inspectiver reserves the right to update these Terms at any time. Continued use of the service after changes implies acceptance of the new terms.</span></p>

                        <p><strong><span style={{ fontWeight: "bold" }}>10. Contact</span></strong></p>
                        <p><span>For questions or support, contact us at:</span></p>
                        <p><span>support@inspectiver.com</span></p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-dark" onClick={handleClose}>Close</button>
                </Modal.Footer>
            </Modal>}
            <Row form>
                <Col md={12}>
                    <FormGroup>
                        <Input
                            id="requesterNote"
                            type="textarea"
                            name="requesterNote"
                            className="form-control"
                            placeholder="Please enter if you have any note to inspector (optional)"
                            value={requesterNote}
                            onChange={e => updateFields({ requesterNote: e.target.value })}
                        />
                    </FormGroup>
                </Col>
                <Col md={12}>
                    <FormGroup>
                        <div className="form-group mb-0 mt-5">
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="termsAndContidition" checked={isTermsAndConditionChecked} onChange={checkHandler} />
                                <label className="form-check-label" for="termsAndContidition" >I accept </label> <label><a style={{ cursor: "pointer", textDecorationLine: "underline" }} onClick={() => openTermsAndConditionModal()} >Terms and Conditions </a></label>
                            </div>
                        </div>
                    </FormGroup>
                </Col>
            </Row>
        </>
    )
}
